import React, {Component, Fragment} from 'react';
import {connect} from "react-redux";
import ReactHtmlParser from 'react-html-parser';

import {getFullMediaUrl} from 'app/static_func';

import HiddenParagraph from 'components/hiddenParagraph/hiddenParagraph.js';

import './about.scss'
import tree from 'assets/icons/tree_img.svg';
import road from 'assets/icons/road_img.svg';
import treeDesktop from 'assets/icons/bottom_tree_desktop.svg';

class About extends Component{
    constructor(props){
        super(props);

        this.state = {
            fullParaDisplay:false,
            link:'קרא עוד'
        }

        this.handleReadeMoreOnClick = this.handleReadeMoreOnClick.bind(this);
    }


    handleReadeMoreOnClick(){
        if(this.state.link === 'קרא עוד')
            this.setState({fullParaDisplay: true, link: 'הסתר'});
        else
            this.setState({fullParaDisplay: false, link: 'קרא עוד'});

    }

    render(){
        const left = this.props.whoAreWe.left;
        const right = this.props.whoAreWe.right;
        const isLaptopOrDesktop = this.props.deviceState === 'desktop' || this.props.deviceState === 'desktop_large';

        return(
            <section className="about">
                {!isLaptopOrDesktop &&
                <Fragment>
                    <h3 className='title'>{this.props.text['about_title']}</h3>
                    <div className='topDivider'></div>
                    <div className='staffContainer'>
                        <div className='person'>
                            <img className="passportPhoto" src={(left!==undefined ? getFullMediaUrl(left.image['path']) : '')} alt="person"/>
                        </div>
                        <div className='person'>
                            <img className="passportPhoto" src={(right!==undefined ? getFullMediaUrl(right.image['path']) : '')} alt="person"/>
                        </div>
                    </div>

                    <HiddenParagraph className = 'paragraphContainer'>
                        {ReactHtmlParser(this.props.whoAreWe.content)}
                    </HiddenParagraph>

                    <div className='imgContainer'>
                        <img className={'bottomTreeImg'} src={tree} alt="img" />
                        <img className={'bottomRoadImg'} src={road} alt="img" />
                    </div>
                </Fragment>
                }
                {isLaptopOrDesktop &&
                <Fragment>
                    <div className='aboutContainer'>
                        <div className='textContainer'>
                            <h3 className='title'>{this.props.text['about_title_desktop']}</h3>
                            <div className='aboutDivider'/>
                            <div className='paraContainer'>
                                <div className='para'>{ReactHtmlParser(this.props.whoAreWe.content)}</div>
                            </div>
                        </div>
                        <div className='staffContainer'>
                            <div className='person'>
                                <img className="passportPhoto" src={(left!==undefined ? getFullMediaUrl(left.image['path']) : '')} alt="person"/>
                            </div>
                            <div className='person'>
                                <img className="passportPhoto" src={(right!==undefined ? getFullMediaUrl(right.image['path']) : '')} alt="person"/>
                            </div>
                        </div>
                    </div>
                    <img src={treeDesktop} className='bottomImg' alt='/'/>
                </Fragment>
                }
            </section>
        )
    }
}

//add GD categories and deviceState to props
const mapStateToProps = store => {
    return {
        deviceState: store.state.deviceState,
        whoAreWe: store.config.WhoAreWe,
        text: store.config.Translations,
    }
}
//map a doLgin function to props
const mapDispatchToProps = dispatch => {
    return {

    }
}

//connect to redux store - maps dispatch and redux state to props
export default connect(mapStateToProps, mapDispatchToProps, null, { pure: false })(About);